import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../../redux/store.model';
import {
  NavigationPathProps,
  getParamsGenerator,
  inferSubModuleSelected,
  navigationPath,
} from '../../navigations/navigationPath';
import { HandlingErrorWrappedProps } from '../../../../handlingErrors';
import { RouterComponentProps } from '../../../../util/route-dom';
import { getGroupSelectedByQueryParamSelector } from '../../../../redux/groups/selectors';
import { getDeviceSelectedName } from '../../../../redux/commander/selectors';
import { getControlUnitSelectedByQueryParamSelector } from '../../../../redux/controlUnit/selectors';

const patterns = [
  '/devicemanager/device/:deviceId/group/:groupId/device-detail/control-unit/:controlUnitId/:moduleSelected/*',
  '/devicemanager/device/:deviceId/device-detail/control-unit/:controlUnitId/:moduleSelected/*',
];
export const getParamsControlUnit = getParamsGenerator(patterns);
export const getModuleSelectedControlUnit = (pathname: string) =>
  getParamsControlUnit(pathname).moduleSelected ?? '';

const dicTitles: Record<string, string> = {
  events: 'device.events.events',
  parameters: 'device.parameters.title',
  history: 'device.monitoring.title',
  alarms: 'incident.all_alarms',
};

const getProps = (
  _: RootState,
  props: NavigationPathProps &
    HandlingErrorWrappedProps &
    RouterComponentProps<{
      groupId?: string;
      controlUnitId: string;
      deviceId: string;
    }>
) => props;

export const getDeviceSectionsNavigationSelector = createSelector(
  [
    getProps,
    getGroupSelectedByQueryParamSelector,
    getDeviceSelectedName,
    getControlUnitSelectedByQueryParamSelector,
  ],
  (props, group, deviceName, controlUnit) => {
    const {
      polyglot,
      navigate,
      location: { pathname },
      params: { controlUnitId, deviceId, groupId },
    } = props;

    /** Commander */
    const urlCommander = groupId
      ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/`
      : `/devicemanager/device/${deviceId}/device-detail/`;
    const navigators = navigationPath(props, groupId, group).concat([
      {
        content: deviceName || '...',
        href: urlCommander,
      },
    ]);

    /** ControlUnit */
    if (controlUnitId) {
      const urlControlUnit = groupId
        ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/control-unit/${controlUnitId}`
        : `/devicemanager/device/${deviceId}/device-detail/control-unit/${controlUnitId}`;
      navigators.push({
        content: controlUnit?.name ?? '...',
        href: urlControlUnit,
      });
    }

    /** module selected */
    const params = getParamsControlUnit(pathname);
    const moduleSelected = params.moduleSelected;
    const moduleUrl = groupId
      ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/control-unit/${controlUnitId}/${moduleSelected}`
      : `/devicemanager/device/${deviceId}/device-detail/control-unit/${controlUnitId}/${moduleSelected}`;
    if (
      moduleSelected &&
      Object.keys(dicTitles).includes(moduleSelected ?? '')
    ) {
      navigators.push({
        content: polyglot.t(dicTitles[moduleSelected] ?? ''),
        href: moduleUrl,
      });
    }
    const subModules = inferSubModuleSelected(params);
    navigators.push(...subModules);
    return navigators;
  }
);
